import { BlockDefinition } from '../../types'
import MediaBlock from './MediaBlock'
import { mediaSupportsFullWidth } from './fullWidth'

// Legacy equivalents: embededaudio (Cloudinary), embededvideo (Vimeo) and
// video (hosted)
const mediaBlock: BlockDefinition<'media'> = {
  type: 'media',
  createDefaultProps: () => ({
    kind: null,
    src: null,
    poster: null,
    host: null,
    hostId: null,
    hostMediaId: null,
    caption: ''
  }),
  Component: MediaBlock,
  supportsFullWidth: mediaSupportsFullWidth
}

export default mediaBlock
